"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _utils = require("webmotors-react-pj/utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const objAdobeTrackingDefault = () => ({
  site: {
    domain: window.location.hostname,
    country: undefined,
    server: "web",
    environment: 'cockpit',
    tmsVersion: undefined,
    clientType: 'pj',
    platform: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent || navigator.vendor || window.opera) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent || navigator.vendor || window.opera.substr(0, 4)) ? 'mobile' : 'desktop'
  },
  page: {
    status: 200,
    url: window.location.href,
    loadTime: window.performance.PerformanceNavigationTiming,
    trackingCode: {
      idcmp: undefined,
      idcmpint: undefined,
      icid: undefined,
      lkid: undefined
    }
  },
  products: {
    dealer: {
      totalItems: undefined,
      totalPrice: undefined,
      items: [{
        sku: undefined,
        name: undefined,
        feirao: undefined,
        regiao: undefined,
        plano: undefined,
        duracao: undefined
      }]
    }
  },
  user: {
    loginStatus: undefined,
    cockpitUserId: undefined,
    clientId: undefined,
    typeId: undefined,
    cnpj: undefined
  }
});
const dispatchEventTagManager = e => console.log("".concat(e.type, ": ").concat(window.objDataLayer.page.pageName));
var _default = exports.default = function _default() {
  var _window, _window$env, _window$env$i18n, _window$env$i18n$coun, _dataLayer$site, _dataLayer$site$count;
  let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'customPageView';
  let dataLayer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    objDataLayer
  } = window;
  const objAdobeTracking = objDataLayer && objDataLayer.site ? _objectSpread({}, objDataLayer) : objAdobeTrackingDefault();
  const {
    sid,
    unique_name,
    role,
    cnpj
  } = (0, _utils.jwtGet)();
  const statusLogged = {
    logged: 1,
    noLogged: 2
  };
  Object.entries(dataLayer).forEach(item => {
    const [key, value] = item;
    objAdobeTracking[key] = _objectSpread(_objectSpread({}, objAdobeTracking[key]), value);
  });
  const {
    site,
    user,
    page
  } = objAdobeTracking;
  site.country = ((_window = window) === null || _window === void 0 ? void 0 : (_window$env = _window.env) === null || _window$env === void 0 ? void 0 : (_window$env$i18n = _window$env.i18n) === null || _window$env$i18n === void 0 ? void 0 : (_window$env$i18n$coun = _window$env$i18n.country) === null || _window$env$i18n$coun === void 0 ? void 0 : _window$env$i18n$coun.toLowerCase()) || (dataLayer === null || dataLayer === void 0 ? void 0 : (_dataLayer$site = dataLayer.site) === null || _dataLayer$site === void 0 ? void 0 : (_dataLayer$site$count = _dataLayer$site.country) === null || _dataLayer$site$count === void 0 ? void 0 : _dataLayer$site$count.toLowerCase()) || '';
  user.loginStatus = sid !== '' ? statusLogged.logged : statusLogged.noLogged;
  user.cockpitUserId = sid;
  user.clientId = unique_name;
  user.typeId = typeof role === 'object' ? [...role] : [role];
  user.cnpj = cnpj;
  if (!page.trackingCode) {
    page.trackingCode = {};
  }
  const params = window.location.search;
  const searchParams = new URLSearchParams(params);
  page.trackingCode.idcmp = searchParams.get('idcmp');
  page.trackingCode.idcmpint = searchParams.get('idcmpint');
  page.trackingCode.icid = searchParams.get('icid');
  page.trackingCode.lkid = searchParams.get('lkid');
  window.objDataLayer = objAdobeTracking;
  document.addEventListener(event, dispatchEventTagManager);
  document.dispatchEvent(new CustomEvent(event, {
    detail: objAdobeTracking
  }));
  document.removeEventListener(event, dispatchEventTagManager);
};